var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConversation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3.5C5.134 3.5 2 6.186 2 9.5C2 10.627 2.369 11.6771 3 12.5781V16.2168C3 16.7458 3.60434 17.0485 4.02734 16.7305L6.28906 15.0332C7.12206 15.3332 8.039 15.5 9 15.5C12.866 15.5 16 12.814 16 9.5C16 6.186 12.866 3.5 9 3.5ZM17.9766 9.07422C17.9846 9.21622 18 9.357 18 9.5C18 13.911 13.963 17.5 9 17.5C8.98 17.5 8.96041 17.4961 8.94141 17.4961C10.1514 19.2891 12.409 20.5 15 20.5C15.961 20.5 16.8769 20.3332 17.7109 20.0332L19.9746 21.7305C20.3966 22.0475 21 21.7448 21 21.2168V17.5781C21.631 16.6771 22 15.627 22 14.5C22 12.1 20.3526 10.0342 17.9766 9.07422Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversation);
export default __webpack_public_path__ + "static/media/conversation.ad177fb61a187fc0582c8a169f188254.svg";
export { ForwardRef as ReactComponent };